<template>
  <div
    :class="ficheInfos.bgColorText"
    class="ficheWrap flex flex-col justify-start items-center w-full mb-10 md:mb-0"
  >
    <div :class="ficheInfos.bgColor" class="w-full">
      <img :src="ficheInfos.path" :alt="ficheInfos.title" class="m-auto" />
      <h3 :class="ficheTitlePadding" class="mb-3 px-5 md:px-0">
        {{ ficheInfos.title }}
      </h3>
    </div>

    <div class="px-5 md:px-0 w-full">
      <ul
        class="ficheWrap__list list-none md:list-disc text-2xl pb-3 md:text-med md:pl-4 md:pb-3"
      >
        <li v-for="ficheItem in ficheInfos.ficheItems" :key="ficheItem.item">
          {{ ficheItem.item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ficheInfos: {
      type: Object
    }
  },
  computed: {
    ficheTitlePadding: function () {
      if (this.ficheInfos.title === 'Gestion Documentaire') {
        return 'ficheTitlePadding'
      }
    }
  }
}
</script>

<style lang="css" scoped>
h3 {
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 6vw;
}

li {
  margin: 5vw 0;
  margin-left: 6vw;
}

.ficheWrap {
  width: 90%;
}

.ficheWrap__list {
  font-weight: normal;
  max-width: 100%;
}

.ficheTitlePadding {
  padding: 0 1vw;
}

.bg-maquamarine--92 {
  background-color: rgba(93, 185, 157, 0.9);
}

.bg-sandybrown--92 {
  background-color: rgba(247, 198, 106, 0.9);
}

.bg-mturquoise--92 {
  background-color: rgba(82, 207, 235, 0.9);
}

@media screen and (min-width: 768px) {
  h3 {
    font-size: 1.2vw;
  }

  li {
    margin: 0.6vw 0;
  }

  li::before {
    content: none;
  }

  .ficheWrap {
    width: 32%;
    padding: 0;
  }

  .ficheWrap div {
    padding: 0 1vw;
  }

  .ficheWrap__list {
    font-weight: normal;
    margin-top: 2%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Fiche.vue